import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { ReferenceType } from 'src/app/shared/model/ReferenceType';
import { UploadFilesSettings } from '../../models/UploadFilesSettings';
import { UploadDocumentParameters } from '../../models/UploadDocumentParameters';

@Component({
  selector: 'app-show-linked-docs',
  templateUrl: './show-linked-docs.component.html',
  styleUrls: ['./show-linked-docs.component.scss']
})
export class ShowLinkedDocsComponent  extends DialogContentBase implements OnInit {

  constructor(public dialog: DialogRef) {
    super(dialog);
    }

  @Input() public referenceId: string;
  @Input() public referenceType: ReferenceType;
  @Input() public documentTypeId: number;
  @Input() public uploadDocumentsDescription = '';

  uploadFilesSettings: UploadFilesSettings;

  ngOnInit(): void {
  const uploadDocumentParameters :  UploadDocumentParameters =  {
      documentTypeId: this.documentTypeId,
      referenceType: this.referenceType,
      referenceId: this.referenceId,
      otherDocumentKindName : '',
      description: this.uploadDocumentsDescription,
      proofDocumentIds: []
    }

    this.uploadFilesSettings  = {
      uploadDocumentParameters : uploadDocumentParameters,
      fileRestrictions: null,
      showTopButtons: false,
      autoUpload : false,
      showDocumentDataDialog: false,
      documentDataDialogContent: null
    };    
  }
    
  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }
}
